import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { ScreenRecorderModalComponent } from './screen-recorder-modal.component';
import { ScreenRecorderIndicatorComponent } from './screen-recorder-indicator.component';
import { ScreenRecorderNavIndicatorComponent } from './screen-recorder-nav-indicator.component';
import { ScreenRecorderService } from './screen-recorder.service';

@NgModule({
  declarations: [
    ScreenRecorderModalComponent,
    ScreenRecorderIndicatorComponent,
    ScreenRecorderNavIndicatorComponent
  ],
  imports: [
    CommonModule,
    FormsModule
  ],
  exports: [
    ScreenRecorderModalComponent,
    ScreenRecorderIndicatorComponent,
    ScreenRecorderNavIndicatorComponent
  ]
})
export class ScreenRecorderModule { }
